import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgLeaderboardSecondBadge = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 45,
  viewBox: "0 0 28 45",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsx("circle", {
    cx: 14,
    cy: 19.5,
    r: 12,
    fill: "#1C456B"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#1C456B",
    d: "M23.276 41.88c.311 1.557-1.23 2.84-2.704 2.25l-5.829-2.332a2 2 0 0 0-1.486 0l-5.829 2.331c-1.475.59-3.015-.691-2.704-2.249l1.796-8.979c.135-.679.904-1.019 1.53-.724A13.95 13.95 0 0 0 14 33.5c2.127 0 4.144-.475 5.95-1.324.625-.295 1.394.045 1.53.724z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#A7E3E3",
    d: "M14.132 18.988q.272-.432.384-.768.128-.352.128-.656 0-.593-.4-.912-.384-.336-1.104-.336-.513 0-1.12.192a4.4 4.4 0 0 0-1.12.512l-.592-2.032q.607-.495 1.504-.752a6.1 6.1 0 0 1 1.776-.272q1.072 0 1.904.4.848.384 1.328 1.152.48.752.48 1.824a4.2 4.2 0 0 1-.32 1.6q-.305.784-1.008 1.824l-2.016 2.992-.304-.544h3.984V25.5h-7.568z"
  })]
});
export default SvgLeaderboardSecondBadge;